const $ = require('jquery');
const _ = require('lodash');
const gtm = require('../../helpers/gtm')

const $menu = $('#menu');
let $subMenu = null;
// '$(#menuDrop)' gets replaced after pjax, to update contents of it correctly.
// So here can save only target class/id
const menuDropTarget = '#menuDrop';
const subMenuDropTarget = '#subMenuDrop';

// Ar kādu intervālu pieprasam status updates
const status_update_timeout = 15000;

// Ar kādu intervālu pieprasam status updates + vēstuļu ielāde
// intervāls, kad atvērta sākumlapa, kur ir vēstules vai vēstuļu sadaļa
const messages_update_timeout = 5000;

// Lietotāja parametri
let properties = {
  new_visit_count: 0,
  new_like_count: 0,
  new_wink_count: 0,
  unread_conversations_count: 0,
  new_events: 0,
  new_statistics: 0,
  unread_discussions_count: 0,
  unread_my_discussions_count: 0,
  unread_my_posts_discussions_count: 0,
};

// Objektu izmaiņu klausītāji
const listeners = {};

/**
 * Konkrēta lietotāja parametra izmaiņu klausīšanās uzsākšana
 *
 * @param string name Parametra key
 * @param function callback Callback funkcija
 * @options object options Klausītāja papildus parametri
 */
const listenProperty = function (name, callback, options) {
  if (typeof options === 'undefined') {
    var options = {
      update: true,
    };
  }

  listeners[name] = {
    val: properties[name],
    callback,
    options,
  };
};

/**
 * Inicializē lietotāja parametru klausītājus
 */
const callPropertyListeners = function () {
  for (const k in listeners) {
    let val = null;
    if (typeof properties[k] !== 'undefined') {
      val = properties[k];
    }

    listeners[k].callback.call(this, name, listeners[k].val, val);

    if (listeners[k].options.update) {
      listeners[k].val = val;
    }
  }
};

/**
 * Pieprasa serverim lietotāja pašreizējos parametrus
 */
var statusUpdates = function (init, forced) {
  if (typeof init === 'undefined' && !init) {
    const updateUrl = `${_.get(globals, 'apiWebroot', '/')}member/properties?conversations=1`;
    const request = $.get(updateUrl)
      .then((response) => {
        $subMenu = $('#subNav');
        if ((!_.isObject(response) && !_.isString(response)) || _.isEmpty(response)) {
          return;
        }

        if (_.isString(response)) {
          // ja atbilde ir txt, tad pārveido uz json
          response = JSON.parse(response);
        }

        if (response.url) {
          window.location = response.url;
          return;
        }
        properties = response;
        callPropertyListeners();
      });
  }

  if (typeof forced === 'undefined' && !forced) {
    self.setTimeout(() => {
      statusUpdates();
    }, status_update_timeout);
  }
};

/**
* Elementam pievieno/noņem notifikāciju
*/
const addNotification = function ($item, val, limit = 0) {
  if (!$item.length) {
    return false;
  }
  const $notification = $item.find('.menu-notification');

  if ($notification.length) {
    if (val > 0) {
      if (limit != 0 && val > limit) {
        val = `${limit}+`;
      }
      $notification.text(val);
      $notification.hide().show(0); // bug fix, jo chrome pēc update neparāda izmaiņas
    } else {
      $notification.remove();
    }
    return true;
  }

  if (!$notification.length && val > 0) {
    $item.append(`<span class="menu-notification">${val}</span>`);
  }
};

/**
* Statistikas submenu pievieno notifikācijas
*/
const addStatisticNotification = function (pageClass, val) {
  const path = location.pathname;

  const $subMenuDrop = $(subMenuDropTarget);

  // nav submenu vai nav statistikas lapa
  if ((!$subMenu.length && !$subMenuDrop.length) || path.indexOf('statistics') === -1) {
    return false;
  }

  if ($subMenu.length) {
    const $statistic_notification_item = $subMenu.find(`${pageClass} a`);
    addNotification($statistic_notification_item, val);
  }

  if ($subMenuDrop.length) {
    const $statistic_notification_item_drop = $subMenuDrop.find(`${pageClass} a`);
    addNotification($statistic_notification_item_drop, val);
  }
};

/**
* Diskusijas submenu pievieno notifikācijas
*/
const addDiscussionsNotification = function (pageClass, val, limit = 0) {
  const path = location.pathname;

  const $subMenuDrop = $(subMenuDropTarget);

  // nav submenu vai nav diskusijas lapa
  if ((!$subMenu.length && !$subMenuDrop.length) || path.indexOf('discussions') === -1) {
    return false;
  }

  if ($subMenu.length) {
    const $discussions_notification_item = $subMenu.find(`${pageClass} a`);
    addNotification($discussions_notification_item, val, limit);
  }

  if ($subMenuDrop.length) {
    const $discussions_notification_item_drop = $subMenuDrop.find(`${pageClass} a`);
    addNotification($discussions_notification_item_drop, val, limit);
  }
};

/**
* Pasākumu submenu pievieno notifikācijas
*/
const addHappeningsNotification = function (pageClass, val, limit = 0) {
  const path = location.pathname;

  const $subMenuDrop = $(subMenuDropTarget);

  // nav submenu vai nav pasākumu/bloga lapa
  if ((!$subMenu.length && !$subMenuDrop.length) || (path.indexOf('happenings') === -1 && path.indexOf('blog') === -1)) {
    return false;
  }

  if ($subMenu.length) {
    const $happenings_notification_item = $subMenu.find(`${pageClass} a`);
    addNotification($happenings_notification_item, val, limit);
  }

  if ($subMenuDrop.length) {
    const $happenings_notification_item_drop = $subMenuDrop.find(`${pageClass} a`);
    addNotification($happenings_notification_item_drop, val, limit);
  }

  return 1;
};

/**
* Saderību submenu pievieno notifikācijas
*/
const addMatchesNotification = function (pageClass, val, limit = 0) {
  const path = location.pathname;

  const $subMenuDrop = $(subMenuDropTarget);

  // nav submenu vai nav saderību lapa
  if ((!$subMenu.length && !$subMenuDrop.length) || path.indexOf('matches') === -1) {
    return false;
  }

  if ($subMenu.length) {
    const $matches_notification_item = $subMenu.find(`${pageClass} a`);
    addNotification($matches_notification_item, val, limit);
  }

  if ($subMenuDrop.length) {
    const $matches_notification_item_drop = $subMenuDrop.find(`${pageClass} a`);
    addNotification($matches_notification_item_drop, val, limit);
  }
};

module.exports = {
  init() {
    // kamēr nav member zināms, tikmēr neizsauc
    if (!_.get(globals, 'currentMember.id', false)) {
      return;
    }
    this.addListenProperties();
    statusUpdates(true);
  },
  addListenProperties() {
    // Lietotāja parametra 'new_statistics' izmaiņu klausītājs un callback funkcija
    // Kopējais statistikas skaitlis
    listenProperty('new_statistics', (name, oldval, val) => {
      const $statistics_item = $menu.find('a[data-name="statistics"]');
      addNotification($statistics_item, val);

      addNotification($('.burger-menu'), val);

      const $statistics_item_drop = $(menuDropTarget).find('a[data-name="statistics"]');
      addNotification($statistics_item_drop, val);

      addStatisticNotification('.activities-all', val);
    });

    // Lietotāja parametra 'unread_conversations_count' izmaiņu klausītājs un callback funkcija
    // Neizlasītās sarakstes
    listenProperty('unread_conversations_count', (name, oldval, val) => {
      const $messages_item = $menu.find('a[data-name="messages"]');
      addNotification($messages_item, val);

      addNotification($('.quick-menu-messages'), val);
    });

    // Lietotāja parametra 'new_visit_count' izmaiņu klausītājs un callback funkcija
    listenProperty('new_visit_count', (name, oldval, val) => {
      addStatisticNotification('.visitors', val);
    });

    // Lietotāja parametra 'new_wink_count' izmaiņu klausītājs un callback funkcija
    listenProperty('new_wink_count', (name, oldval, val) => {
      addStatisticNotification('.winks', val);
    });

    // Lietotāja parametra 'new_like_count' izmaiņu klausītājs un callback funkcija
    listenProperty('new_like_count', (name, oldval, val) => {
      addStatisticNotification('.image-likes', val);
    });

    // Lietotāja parametra 'unread_discussions_count' izmaiņu klausītājs un callback funkcija
    // Neizlasītās diskusijas
    listenProperty('unread_discussions_count', (name, oldval, val) => {
      const $discussions_item = $menu.find('a[data-name="discussions"]');
      addNotification($discussions_item, val, 50);
      // visas sarumas notifikācijas nerādīt
      // addDiscussionsNotification('.all-discussions', val, 50);

      const $discussions_item_drop = $(menuDropTarget).find('a[data-name="discussions"]');
      addNotification($discussions_item_drop, val);
    });

    // Lietotāja parametra 'unread_my_discussions_count' izmaiņu klausītājs un callback funkcija
    listenProperty('unread_my_discussions_count', (name, oldval, val) => {
      addDiscussionsNotification('.my-discussions', val);
    });

    // Lietotāja parametra 'unread_my_posts_discussions_count' izmaiņu klausītājs un callback funkcija
    listenProperty('unread_my_posts_discussions_count', (name, oldval, val) => {
      addDiscussionsNotification('.my-posts', val);
    });

    listenProperty('new_happenings', (name, oldval, val) => {
      const $happening_item = $menu.find('a[data-name="blog"]');
      addNotification($happening_item, val);

      const $happening_item_drop = $(menuDropTarget).find('a[data-name="blog"]');
      addNotification($happening_item_drop, val);
    });

    listenProperty('new_blogs', (name, oldval, val) => {
      addHappeningsNotification('.blog', val);
    });

    listenProperty('unread_happenings_count', (name, oldval, val) => {
      addHappeningsNotification('.all-happenings', val);
    });

    listenProperty('unread_my_happenings_count', (name, oldval, val) => {
      addHappeningsNotification('.my-happenings', val);
    });

    listenProperty('unread_my_posts_happenings_count', (name, oldval, val) => {
      addHappeningsNotification('.my-posts-happenings', val);
    });

    listenProperty('new_match_count', (name, oldval, val) => {
      addMatchesNotification('.my-matches', val);
    });

    listenProperty('new_likes_count', (name, oldval, val) => {
      addMatchesNotification('.likes-me', val);
    });

    listenProperty('new_matches_count', (name, oldval, val) => {
      const $matches_item = $menu.find('a[data-name="matches"]');
      addNotification($matches_item, val, 50);
    });

    // Lietotāja parametra 'new_events' izmaiņu klausītājs un callback funkcija
    // Nomaina lapas title
    listenProperty('new_events', (name, oldval, val) => {
      const update_pattern = /^\([0-9]+\) /g;
      const old_title = document.title;

      val = val > 0 ? `(${val}) ` : '';

      document.title = update_pattern.test(old_title) ? old_title.replace(update_pattern, val) : val + old_title;
    });
  },
  // paredzēts, lai varētu no malas atjaunot skaitu, piem. no react puses
  updateConversationsCount(val) {
    if (!listeners.unread_conversations_count) {
      return;
    }
    listeners.unread_conversations_count.callback.call(this, name, listeners.unread_conversations_count.val, val);

    if (listeners.unread_conversations_count.options.update) {
      listeners.unread_conversations_count.val = val;
    }
  },
  // darbības, kuras jāveic pēc login
  finishRequest() {
    if (!_.get(globals, 'initLogin', false)) {
      return;
    }

    //
    const lastLoginType = _.get(globals, 'currentMember.lastLoginType', '');
    if (window.location.pathname.indexOf('welcome') != -1) {
      gtm.track({ event: 'register', registerMethod: lastLoginType });
    } else {
      gtm.track({ event: 'login', loginMethod: lastLoginType });
    }

    //
    const params = {};
    //
    /* const cv = `; ${document.cookie}`;
    const cp = cv.split(`; _ga=`);
    if (cp.length === 2) {
      const gacp = cp.pop().split(';').shift().split('.');
      if (gacp.length === 4) {
        params.cid = gacp.slice(-2).join('.');
      }
    } */

    $.get(`${_.get(globals, 'apiWebroot', '/')}auth/finish_login`, params);
  },
  listenExternalProperty(name, callback, options, defval) {
    properties[name] = defval;
    listenProperty(name, callback, options);
  },
};
